import { useState } from 'react';
import Button from './ui/Button';
import Input from './ui/Input';

interface ShareDialogProps {
  posterId: string;
  onClose: () => void;
}

export default function ShareDialog({ posterId, onClose }: ShareDialogProps) {
  const baseUrl = window.location.origin;
  const shareUrl = `${baseUrl}/p/${posterId}`;

  const [copied, setCopied] = useState(false);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(shareUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center 
                 z-50 p-4"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-xl p-6 max-w-lg w-full shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-2xl font-display font-bold text-neutral-900 mb-4">
          Share Poster
        </h2>
        <p className="text-base text-neutral-600 mb-4">
          Share this link to allow others to view your poster:
        </p>
        <div className="flex flex-col sm:flex-row gap-3 mb-4">
          <Input
            type="text"
            value={shareUrl}
            readOnly
            className="flex-1 text-sm"
          />
          <Button
            variant={copied ? 'success' : 'primary'}
            onClick={copyToClipboard}
            className="sm:w-auto w-full"
          >
            {copied ? 'Copied!' : 'Copy'}
          </Button>
        </div>
        <Button variant="secondary" onClick={onClose} className="w-full">
          Close
        </Button>
        <div className="mt-4 pt-4 border-t border-neutral-200">
          <p className="text-xs text-neutral-400 text-center">
            Powered by{' '}
            <a
              href="https://teiko-labs.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-neutral-500 hover:text-neutral-600 transition-colors"
            >
              teiko-labs.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
